<mat-form-field appearance="outline" fxFlex [formGroup]="settings.form">
  <mat-label>{{ settings.nazev }}</mat-label>
  <input
    matInput
    [formControlName]="settings.formControlName"
    [matDatetimepicker]="datetimePicker"
    placeholder="{{ settings.nazev }}"
    [required]="settings.povinnost"
    (click)="datetimePicker.open()"
  />
  <mat-hint *ngIf="settings.napoveda && !settings.napoveda.isIcon">{{settings.napoveda.text}}</mat-hint>
  <mat-icon *ngIf="settings.napoveda && settings.napoveda.isIcon" matSuffix [matTooltip]="settings.napoveda.text">info</mat-icon>

  <mat-datetimepicker #datetimePicker class="picker"
    type="datetime"
    openOnFocus="true"

    timeInterval="5"
    enableMeridian='false'
    touchId="true"
  ></mat-datetimepicker>

  <!-- <mat-error *ngIf="settings.form.get(settings.formControlName)?.errors"><div *ngIf="settings.form.get(settings.formControlName)?.errors.pkerror">{{settings.form.get(settings.formControlName)?.errors}}</div>Toto pole je povinné!</mat-error> -->
  <mat-error *ngIf="firstError">
    {{firstError}}
  </mat-error>
</mat-form-field>
